import React, {useRef, useState, useEffect} from 'react';
import BirdGenerator from '../bird-generator/bird-generator';
import PropTypes from 'prop-types';
import './background.scss';

const Background = ({
	backgroundId = 'default',
	backgroundModifier,
	backgroundStatus,
	updateBackgroundStatus
}) => {	
	/* Transition ref */
	const transitionTimeout = useRef(null);
	
	/* Current background and position */
	const [currentBackgroundId, setCurrentBackgroundId] = useState(backgroundId);
	const [currentBackgroundModifier, setcurrentBackgroundModifier] = useState(backgroundModifier);
	let modifiedBackgroundStatus = backgroundStatus;
	/**
	 * Update background
	 */
	useEffect(() => {
		if (backgroundId !== currentBackgroundId) {
			if (transitionTimeout.current) clearTimeout(transitionTimeout.current);
			/* New background id: fade between backgrounds */
			transitionTimeout.current = setTimeout(() => {
				setCurrentBackgroundId(backgroundId);
				setcurrentBackgroundModifier(backgroundModifier);
				updateBackgroundStatus('show');
			}, 1000);
		} else {
			if (backgroundModifier !== currentBackgroundModifier) {
				/* New background position: pan to position */
				setcurrentBackgroundModifier(backgroundModifier);
				let timeoutDuration = 2000;
				if (currentBackgroundModifier === 'top' && backgroundModifier === 'bottom') {
					timeoutDuration = 4000;
				}
				if (
					currentBackgroundModifier === 'classroom-8a-issues' || 
					backgroundModifier === 'classroom-8a-issues'
				) {
					timeoutDuration = 0;
				}
				if (transitionTimeout.current) clearTimeout(transitionTimeout.current);
				transitionTimeout.current = setTimeout(() => {
					updateBackgroundStatus('show');
				}, timeoutDuration);
			}
		}
		
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [backgroundId, backgroundModifier]);

	/**
	 * Component mounted / will unmount
	 */
	useEffect(() => {
		/* Component mounted */		
		
		return () => {
			/* Component will unmount */
				
			if (transitionTimeout.current) clearTimeout(transitionTimeout.current);
			
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	return (
		<div className={'Background ' + backgroundId}>			
			{/* Background css image */}
			<div 
				className={'Background-imageWrap ' + modifiedBackgroundStatus + ' '
					+ ' ' + currentBackgroundId + ' ' + currentBackgroundModifier
				}>
				<div className={'Background-image1'}/>
				{/* Birds */}
				{backgroundId === 'schoolyard' && <BirdGenerator />}
				<div className={'Background-image2'}/>
			</div>
			
			{/* Fade in/out overlay */}
			<div key={currentBackgroundId} 
				className={'Background-fadeOverlay ' + (backgroundStatus === 'fade' ? 'transitionOut' : 'transitionIn')
				}
			/>
		</div>
	);
};

Background.propTypes = {
	backgroundId: PropTypes.string.isRequired,
	backgroundModifier: PropTypes.string,
	backgroundStatus: PropTypes.string.isRequired,
	updateBackgroundStatus: PropTypes.func.isRequired
};

export default Background;